import { useTranslation } from "react-i18next";

const CardComponent = ({ imgSrc, title, onClick, count, translationKey }) => {
    const { t } = useTranslation();
    return (
        <div
            className="relative flex flex-col items-center shadow-[2px_2px_7px_#8acafb] cursor-pointer justify-center bg-white rounded-xl p-2 hover:shadow-lg transition-all duration-300 my-2 w-[95%] h-[125px]"
            onClick={onClick}
        >
            {/* Blue Badge logic */}
            {count !== null && count !== undefined && (
                <div className="absolute -top-1 -right-1 bg-[#0099ff] text-white text-[14px] font-bold h-10 w-10 rounded-full flex items-center justify-center border-2 border-white shadow-sm z-10">
                    {count}
                </div>
            )}

            <img src={imgSrc} alt={title} className="w-[50%] h-[60%] mb-2" />
            <p className="font-bold text-center text-[13px] text-gray-700">{translationKey ? t(translationKey) : title}</p>
        </div>
    );
}

export default CardComponent;